import type { UseQueryOptions } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import usePersistedQuery from "$src/core/hooks/use-persisted-query";
import type { MenuDto } from "$src/core/models/dto";

const queryKey = () => ["menu"];

const useMenuQuery = (
  options?: Omit<UseQueryOptions<Awaited<MenuDto>>, "queryKey" | "queryFn">,
) => {
  const { api } = useApi();

  return usePersistedQuery({
    queryKey: queryKey(),
    queryFn: api.getMenu,
    ...options,
  });
};

export default useMenuQuery;
